import React from "react";
import EditableTableComponent from "../../../Components/Table/EditableTable";

const KeyCompetitors = () => {
  const columns = [
    { header: "Add Text", accessor: "competition", width: "100px" },
    { header: "Add Text", accessor: "insight", align: "left", width: "250px" },
  ];

  const initialData = [
    {
      competition: "Add Text",
      insight: "Add Text",
    },
    {
      competition: "Add Text",
      insight: "Add Text",
    },
    {
      competition: "Add Text",
      insight: "Add Text​",
    },
  ];

  return (
    <div>
      <EditableTableComponent
        columns={columns}
        initialData={initialData}
        heading={"Key Competitors"}
      />
    </div>
  );
};

export default KeyCompetitors;
